import { create } from 'zustand';

interface LoadingState {
  isLoading: boolean;
  loadingMessage: string | null;
  setLoading: (isLoading: boolean, message?: string) => void;
}

export const useLoadingStore = create<LoadingState>((set) => ({
  isLoading: false,
  loadingMessage: null,
  setLoading: (isLoading: boolean, message?: string) =>
    set({
      isLoading,
      loadingMessage: message || null,
    }),
}));


